import { render } from "./stock-transfer-modal.vue?vue&type=template&id=ff4cbdae"
import script from "./stock-transfer-modal.vue?vue&type=script&lang=js"
export * from "./stock-transfer-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__